import type { FC } from 'react';

interface CloseIconProps {
  color?: string;
}

export const CloseIcon: FC<CloseIconProps> = ({ color = '#E6E6E9' }) => (
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M12 4L4 12M4 4L12 12" stroke={color} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);
